// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uploader {
  width: 90%;
  height: auto;
  max-width: 770px;
  align-self: flex-start;
  margin-top: 140px;
  background-color: #fff;
  border-radius: 10px;
  padding: 30px;
  text-align: left;
  font-family: Arial, Helvetica, sans-serif;
}

.uploader__top {
  padding-left: 15px;
  width: 100%;
  height: auto;
  margin-bottom: 10px;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/components/imageUploader/ImageUploader.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":[".uploader {\n  width: 90%;\n  height: auto;\n  max-width: 770px;\n  align-self: flex-start;\n  margin-top: 140px;\n  background-color: #fff;\n  border-radius: 10px;\n  padding: 30px;\n  text-align: left;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.uploader__top {\n  padding-left: 15px;\n  width: 100%;\n  height: auto;\n  margin-bottom: 10px;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
